import { isTenantAdministrator } from './administratorAccess';

export const canReadDeliveryNotes = user => isTenantAdministrator(user) || Boolean(user?.roles?.some(role => ['VERWALTER', 'MITGLIED'].includes(role.key)));
export const canWriteDeliveryNotes = user => isTenantAdministrator(user) || Boolean(user?.roles?.some(role => role.key === 'VERWALTER'));
